import { gql } from 'graphql-request';

import {
  CompanySmartContractSettingCompanyID,
  CompanySmartContractSettingID,
  CompanySmartContractSettingSplitPartPercents,
  CompanySmartContractSettingUUID
} from '../companySmartContractSettingsTypes';

export interface FetchCacheCompanySmartContractSettingsQueryResponse {
  companyId: CompanySmartContractSettingCompanyID;
  id: CompanySmartContractSettingID;
  uuid: CompanySmartContractSettingUUID;
  splitPartPercents: CompanySmartContractSettingSplitPartPercents;
}

export const FETCH_CACHE_COMPANY_SMART_CONTRACT_SETTINGS_QUERY = gql`
  query CacheCompanySmartContractSettings(
    $filters: CompanySmartContractSettingsFilters
    $limit: Int
    $offset: Int
    $sort: [CompanySmartContractSettingsSortEnum!]
    $source: String
    $trackTotalHits: Boolean
  ) {
    companySmartContractSettings(
      filters: $filters
      limit: $limit
      offset: $offset
      sort: $sort
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        companyId
        id
        uuid
        splitPartPercents
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
      }
      sql
    }
  }
`;
